
import './App.css';
// import markdown from './Components/markdown/markdown';
import Markdownreact from './Components/markdown/MarkDownReact';
function App() {
  return <Markdownreact/>;
}

export default App;
